import type { SVGProps } from 'react'
const SvgSyDollar = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width={24} height={24} {...props}>
		<path d="M25.7 21.3c0 3.6-2.9 6.5-6.5 6.5H17V30c0 .6-.5 1.1-1.1 1.1s-1.1-.5-1.1-1.1v-2.2h-2.2c-3.6 0-6.5-2.9-6.5-6.5 0-.6.5-1.1 1.1-1.1s1.1.5 1.1 1.1c0 2.4 1.9 4.3 4.3 4.3h6.5c2.4 0 4.3-1.9 4.3-4.3S21.5 17 19.1 17h-5.4c-3.6 0-6.5-2.9-6.5-6.5S10.1 4 13.7 4h1.1V1.9c0-.6.5-1.1 1.1-1.1s1.1.5 1.1 1.1v2.2h1.1c3.6 0 6.5 2.9 6.5 6.5 0 .6-.5 1.1-1.1 1.1s-1.1-.5-1.1-1.1c0-2.4-1.9-4.3-4.3-4.3h-4.3c-2.4 0-4.3 1.9-4.3 4.3s1.9 4.3 4.3 4.3h5.4c3.6 0 6.5 2.9 6.5 6.5z" />
	</svg>
)
export default SvgSyDollar
